module.exports = __webpack_public_path__ + "img/edukacija-nastavnika.0ef8127d.jpg";